export const messages = {
  commerce: {
    logo: {
      prefix: 'SALES',
      suffix: 'DUE',
      icon: 'fas fa-meteor'
    },
    sales: {
      payment: 'Payment',
      payments: 'Payments'
    },
    purchases: {
      purchase: 'Purchase',
      purchases: 'Purchases',
      expense: 'Expense',
      expenses: 'Expenses', cashPurchases: 'Cash Purchases',
    },
    appointments: {
      newAppointment: 'New Appointment',
      editAppointment: 'Edit Appointment',
      viewAppointment: 'View Appointment',
      manageAppointments: 'Manage Appointments',
      appointmentDetails: 'Appointment Details',
      createAppointment: 'Create Appointment',
      updateAppointment: 'Update Appointment',
      deleteAppointment: 'Delete Appointment',
      cancelAppointment: 'Cancel Appointment',
      rescheduleAppointment: 'Reschedule Appointment',
      confirmAppointment: 'Confirm Appointment',
      completeAppointment: 'Complete Appointment',
      upcomingAppointments: 'Upcoming Appointments',
      pastAppointments: 'Past Appointments',
      allAppointments: 'All Appointments',
      myAppointments: 'My Appointments',
      appointmentCalendar: 'Appointment Calendar',
      appointmentList: 'Appointment List',
      appointmentStatus: 'Appointment Status',
      appointmentType: 'Appointment Type',
      appointmentDate: 'Appointment Date',
      appointmentTime: 'Appointment Time',
      clientName: 'Client Name',
      serviceProvider: 'Service Provider',
      serviceLocation: 'Service Location',
      notes: 'Notes',
      reminders: 'Reminders',
      notifications: 'Notifications',
      followUp: 'Follow Up',
      walkIn: 'Walk-in',
      virtual: 'Virtual',
      inPerson: 'In-person',
      duration: 'Duration',
      statusScheduled: 'Scheduled',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
      statusNoShow: 'No-show',
      statusRescheduled: 'Rescheduled',
      statusPending: 'Pending',
      statusConfirmed: 'Confirmed',
      appointment: 'Appointment',
      appointments: 'Appointments',
      visit: 'Visit',
      visits: 'Visits',
    },
    sidebar: {
      dashboard: 'Dashboard',
      invoice: 'Invoice',
      invoices: 'Invoices',
      recurringInvoice: 'Recurring Invoice',
      recurringInvoices: 'Recurring Invoices',
      billRun: 'Bill Run',
      billRuns: 'Bill Runs',
      billRunItem: 'Bill Run Item',
      billRunItems: 'Bill Run Items',
      billing: 'Invoices',
      billings: 'Invoices',
      statement: 'Statement',
      statements: 'Statements',
      order: 'Order',
      orders: 'Orders',
      contractor: 'Service Provider',
      contractors: 'Service Providers',
      owner: 'Contact',
      owners: 'Contacts',
      customers: 'Customers',
      customer: 'Customer',
      product: 'Product',
      products: 'Products',
      suppliers: 'Vendors',
      supplier: 'Vendor',
      stock: 'Stock',
      stocks: 'Stocks',
      expenses: 'Expenses',
      cashPurchases: 'Cash Purchases',
      marketing: 'Marketing',
      visit: 'Visit',
      visits: 'Visits',
      accessControl: 'Appointments',
      creditNotes: 'Credit Notes',
      debitNotes: 'Debit Notes',
      business: 'Business',
      businesses: 'Businesses',
      customerGroup: 'Customer Group',
      customerGroups: 'Customer Groups',
      relationship: 'Relationship',
      relationships: 'Relationships',
      personalDetailsTabTitle: 'Basic Details',
      contactDetailsTabTitle: 'Basic Details',
      medicalAidPolicy: 'Payer',
      medicalAidPolicies: 'Payers',
      statement: 'Statement',
      statements: 'Statements',
      statementRun: 'Statement Run',
      statementRuns: 'Statement Runs',
      recurringStatement: 'Recurring Statement',
      recurringStatements: 'Recurring Statement',
      customerBalance: 'Debtors Report',
      customerBalances: 'Debtors Reports',
      communicationLog: 'Communication Log',
      communicationLogs: 'Communication Logs',
      communication: 'Communication',
      communications: 'Communications',
      message: 'Message',
      messages: 'Messages',
      onlinePayment: 'Online Payment',
      onlinePayments: 'Online Payments',
      claims: 'Claims',
      claim: 'Claim',
      claimRemittances: 'Remittances',
      claimRemittance: 'Remittance',
      medicalAids: 'Payers',
      medicalAid: 'Payer',
      insurancePayer: 'Payer',
      insurancePayers: 'Payers',
      medicalAidBalance: 'Balance',
      medicalAidBalances: 'Balances Report',
      more: "More",
      moreFeatures: "More Features",
      apiKeys: "API Keys",
      whiteLists: "White Lists",
      roles: "Roles",
      role: "Role",
      inventory: "Inventory",
      inventories: "Inventories",
      warehouses: "Warehouses",
      warehouse: "Warehouse",
      emailLog: 'Email Log',
      emailLogs: 'Email Logs',
    },
    customer: {
      group: 'Group',
      groups: 'Groups',
    },
    filters: {
      customerNumber: 'Customer Number',
      customerName: 'Customer Name',
      customerEmail: 'Customer Email',
      customerPhone: 'Customer Phone',
    }
  },
  contractor: {
    logo: {
      prefix: 'INVOICE',
      suffix: 'PATROL',
      icon: 'fas fa-meteor'
    },
    sales: {
      payment: 'Payment',
      payments: 'Payments'
    },
    purchases: {
      expense: 'Expense',
      expenses: 'Expenses',
      cashPurchases: 'Cash Purchases',
    },
    sidebar: {
      dashboard: 'Dashboard',
      invoice: 'Invoice',
      invoices: 'Invoices',
      recurringInvoice: 'Recurring Invoice',
      recurringInvoices: 'Recurring Invoices',
      billing: 'Invoices',
      billings: 'Invoices',
      statement: 'Statement',
      statements: 'Statements',
      billRun: 'Bill Run',
      billRuns: 'Bill Runs',
      billRunItem: 'Bill Run Item',
      billRunItems: 'Bill Run Items',
      contractor: 'Service Provider',
      contractors: 'Service Providers',
      owner: 'Owner',
      owners: 'Owners',
      customers: 'Customers',
      customer: 'Customer',
      product: 'Product',
      products: 'Products',
      stock: 'Product',
      stocks: 'Products',
      order: 'Order',
      orders: 'Orders',
      marketing: 'Marketing',
      visit: 'Visit',
      visits: 'Visits',
      accessControl: 'Visitors',
      creditNotes: 'Credit Notes',
      debitNotes: 'Debit Notes',
      business: 'Business',
      businesses: 'Businesses',
    },
    customer: {
      group: 'Group',
      groups: 'Groups',
    },
    filters: {
      customerNumber: 'Customer Number',
      customerName: 'Customer Name',
      customerEmail: 'Customer Email',
      customerPhone: 'Customer Phone',
    }
  },
  fastatext: {
    logo: {
      prefix: 'FASTA',
      suffix: 'TEXT',
      icon: 'fas fa-envelope'
    },
    sales: {
      payment: 'Payment',
      payments: 'Payments'
    },
    purchases: {
      expense: 'Expense',
      expenses: 'Expenses',
      cashPurchases: 'Cash Purchases',
    },
    sidebar: {
      dashboard: 'Dashboard',
      invoice: 'Invoice',
      invoices: 'Invoices',
      recurringInvoice: 'Recurring Invoice',
      recurringInvoices: 'Recurring Invoices',
      billing: 'Invoices',
      billings: 'Invoices',
      statement: 'Statement',
      statements: 'Statements',
      billRun: 'Bill Run',
      billRuns: 'Bill Runs',
      billRunItem: 'Bill Run Item',
      billRunItems: 'Bill Run Items',
      contractor: 'Service Provider',
      contractors: 'Service Providers',
      owner: 'Owner',
      owners: 'Owners',
      customers: 'Customers',
      customer: 'Customer',
      product: 'Product',
      products: 'Products',
      stock: 'Product',
      stocks: 'Products',
      order: 'Order',
      orders: 'Orders',
      marketing: 'Messaging',
      visit: 'Visit',
      visits: 'Visits',
      accessControl: 'Visitors',
      creditNotes: 'Credit Notes',
      debitNotes: 'Debit Notes',
      business: 'Business',
      businesses: 'Businesses',
    },
    customer: {
      group: 'Group',
      groups: 'Groups',
    },
    filters: {
      customerNumber: 'Customer Number',
      customerName: 'Customer Name',
      customerEmail: 'Customer Email',
      customerPhone: 'Customer Phone',
    }
  },
  school: {
    logo: {
      prefix: 'PARENTS',
      suffix: 'PORTAL',
      icon: 'fas fa-graduation-cap'
    },
    sales: {
      payment: 'Payment',
      payments: 'Payments'
    },
    purchases: {
      expense: 'Expense',
      expenses: 'Expenses',
      cashPurchases: 'Cash Purchases',
    },
    sidebar: {
      dashboard: 'Dashboard',
      invoice: 'Invoice',
      invoices: 'Invoices',
      recurringInvoice: 'Fee Structure',
      recurringInvoices: 'Fee Structures',
      billing: 'Invoices',
      billings: 'Invoices',
      statement: 'Statement',
      statements: 'Statements',
      billRun: 'Bill Run',
      billRuns: 'Bill Runs',
      billRunItem: 'Bill Run Item',
      billRunItems: 'Bill Run Items',
      order: 'Order',
      orders: 'Orders',
      contractor: 'Service Provider',
      contractors: 'Service Providers',
      owner: 'Parent',
      owners: 'Parents',
      customers: 'Students',
      customer: 'Student',
      product: 'Fee',
      products: 'Fees',
      stock: 'Fee',
      stocks: 'Fees',
      marketing: 'Communication',
      visit: 'Visit',
      visits: 'Visits',
      accessControl: 'Visitors',
      creditNotes: 'Credit Notes',
      debitNotes: 'Debit Notes',
      business: 'School',
      businesses: 'Schools',
      customerGroup: 'Enrolment',
      customerGroups: 'Enrolments',
    },
    customer: {
      group: 'Class',
      groups: 'Classes',
    },
    filters: {
      customerNumber: 'Student Number',
      customerName: 'Student Name',
      customerEmail: 'Student Email',
      customerPhone: 'Student Phone',
    }
  },
  levies: {
    logo: {
      prefix: 'RESIDENTS',
      suffix: 'PORTAL',
      icon: 'fas fa-meteor'
    },
    sales: {
      payment: 'Payment',
      payments: 'Payments'
    },
    purchases: {
      expense: 'Expense',
      expenses: 'Expenses',
      cashPurchases: 'Cash Purchases',
    },
    sidebar: {
      dashboard: 'Dashboard',
      invoice: 'Invoice',
      invoices: 'Invoices',
      recurringInvoice: 'Levy Structure',
      recurringInvoices: 'Levy Structures',
      billing: 'Invoices',
      billings: 'Invoices',
      statement: 'Statement',
      statements: 'Statements',
      billRun: 'Bill Run',
      billRuns: 'Bill Runs',
      billRunItem: 'Bill Run Item',
      billRunItems: 'Bill Run Items',
      order: 'Order',
      orders: 'Orders',
      cabinMaster: 'Cabin master',
      cabinMasters: 'Cabin masters',
      contractor: 'Service Provider',
      contractors: 'Service Providers',
      visitor: 'Visitor',
      visitors: 'Visitors',
      owner: 'Occupant',
      owners: 'Occupants',
      customers: 'Premises',
      customer: 'Premise',
      product: 'Levy',
      products: 'Levies',
      stock: 'Levy',
      stocks: 'Levies',
      marketing: 'Messages',
      visit: 'Visit',
      visits: 'Visits',
      accessControl: 'Visitors',
      creditNotes: 'Credit Notes',
      debitNotes: 'Debit Notes',
      business: 'Community',
      businesses: 'Communities',
      customerGroup: 'Cluster Premise',
      customerGroups: 'Cluster Premises',
      communicationLog: 'Email Log',
      communicationLogs: 'Email Logs',
      communication: 'Announcement',
      communications: 'Announcements',
    },
    customer: {
      group: 'Cluster',
      groups: 'Clusters',
    },
    filters: {
      customerNumber: 'Premise Number',
      customerName: 'Premise Name',
      customerEmail: 'Premise Email',
      customerPhone: 'Premise Phone',
    }
  },
  medical: {
    logo: {
      prefix: 'MODIAL',
      suffix: 'HEALTH',
      icon: 'fas fa-stethoscope'
    },
    sales: {
      payment: 'Payment',
      payments: 'Payments'
    },
    purchases: {
      expense: 'Expense',
      expenses: 'Expenses',
      cashPurchases: 'Cash Purchases',
    },
    sidebar: {
      dashboard: 'Dashboard',
      invoice: 'Invoice',
      invoices: 'Invoices',
      recurringInvoice: 'Recurring Invoice',
      recurringInvoices: 'Recurring Invoices',
      billing: 'Invoices',
      billings: 'Invoices',
      statement: 'Statement',
      statements: 'Statements',
      billRun: 'Bill Run',
      billRuns: 'Bill Runs',
      billRunItem: 'Bill Run Item',
      billRunItems: 'Bill Run Items',
      order: 'Order',
      orders: 'Orders',
      contractor: 'Service Provider',
      contractors: 'Service Providers',
      owner: 'Contact',
      owners: 'Contacts',
      customers: 'Patients',
      customer: 'Patient',
      product: 'Item',
      products: 'Items',
      stock: 'Service',
      stocks: 'Services',
      marketing: 'Communication',
      visit: 'Appointment',
      visits: 'Appointments',
      accessControl: 'Appointments',
      business: 'Practice',
      businesses: 'Practices',
      customerGroup: 'Patient Group',
      customerGroups: 'Patient Groups',
    },
    customer: {
      group: 'Group',
      groups: 'Groups',
    },
    filters: {
      customerNumber: 'Patient Number',
      customerName: 'Patient Name',
      customerEmail: 'Patient Email',
      customerPhone: 'Patient Phone',
    }
  },
  personal: {
    logo: {
      prefix: 'MY',
      suffix: 'PERSONAL',
      icon: 'fas fa-meteor'
    },
    sales: {
      payment: 'Payment',
      payments: 'Payments'
    },
    purchases: {
      purchase: 'Expense',
      purchases: 'Expenses',
      expense: 'Expense',
      expenses: 'Expenses',
      cashPurchases: 'Cash Purchases',
    },
    sidebar: {
      dashboard: 'Dashboard',
      invoice: 'Invoice',
      invoices: 'Invoices',
      recurringInvoice: 'Recurring Invoice',
      recurringInvoices: 'Recurring Invoices',
      statement: 'Statement',
      statements: 'Statements',
      billRun: 'Bill Run',
      billRuns: 'Bill Runs',
      billRunItem: 'Bill Run Item',
      billRunItems: 'Bill Run Items',
      order: 'Order',
      orders: 'Orders',
      contractor: 'Service Provider',
      contractors: 'Service Providers',
      owner: 'Next of kin',
      owners: 'Next of kins',
      customers: 'Customers',
      customer: 'Customer',
      product: 'Product',
      products: 'Products',
      stock: 'Product',
      stocks: 'Products',
      marketing: 'Communication',
      visit: 'Appointment',
      visits: 'Appointments',
      business: 'Business',
      businesses: 'Businesses',
    },
    customer: {
      group: 'Group',
      groups: 'Groups',
    },
    filters: {
      customerNumber: 'Customer Number',
      customerName: 'Customer Name',
      customerEmail: 'Customer Email',
      customerPhone: 'Customer Phone',
    },
  },
}



// WEBPACK FOOTER //
// ./src/utils/messages.js